module.exports = __webpack_public_path__ + "media/standalone/share-704a8c1d.svg";